<template>
  <div
    id="js-product-details-delivery-dates-simple-container"
    class="product-details-delivery-date-simple"
    :class="{
      'product-details-delivery-date-simple--compact': compact,
      'product-details-delivery-date-simple--same-day': isSameDay
    }"
    :data-product-id="productSlug"
    data-selected-color="Transfer"
    :data-is-dtf="isDtfSheet"
    data-assignable="true"
  >
    <div
      class="product-details-delivery-date-simple__loading js-product-details-delivery-dates-simple-spinner"
    >
      <span class="product-details-delivery-date-simple__loading-text">
        Getting Earliest Delivery Date
      </span>
      <slot name="dates"></slot>
    </div>

    <div
      class="product-details-delivery-date-simple__wrapper js-product-details-delivery-dates-simple-wrapper hidden"
    >
      <div
        class="product-details-delivery-date-simple__delivery js-product-details-delivery-dates-simple-shipment"
      >
        <UseSvg
          icon="box-jiffy-check"
          class="product-details-delivery-date-simple__delivery-icon product-details-delivery-date-simple__delivery-icon--box"
        />
        <UseSvg
          icon="zap-fast"
          class="product-details-delivery-date-simple__delivery-icon product-details-delivery-date-simple__delivery-icon--same-day"
        />
        <span class="product-details-delivery-date-simple__delivery-date-label">
          <span v-if="compact" class="product-details-delivery-date-simple__flash-delivery-label">
            Flash Delivery!
          </span>
          Get it
          <span
            class="js-product-details-delivery-dates-simple-direct-value product-details-delivery-date-simple__delivery-date-value"
          ></span>
        </span>
      </div>

      <div
        class="product-details-delivery-date-simple__cutoff js-product-details-delivery-dates-simple-cutoff-wrapper"
      >
        If ordered in the next
        <b
          class="js-product-details-delivery-dates-cutoff product-details-delivery-date-simple__cutoff-date"
        >
          ...
        </b>
      </div>
      <button
        v-if="!hideAddressLine"
        class="product-details-delivery-date-simple__change-location-button js-deliver-to-toggle-modal"
        type="button"
        data-mixpanel-context="product_detail"
      >
        <UseSvg
          icon="marker"
          class="product-details-delivery-date-simple__change-location-button-icon"
        />

        <span
          class="product-details-delivery-date-simple__deliver-to-message js-deliver-to-pdp-addr"
        >
          Select Your Address
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import UseSvg from "../vue-cart/UseSvg.vue";
import { useDtfStore } from "./store";

export default {
  name: "DeliveryDate",
  components: {
    UseSvg
  },
  props: {
    hideAddressLine: {
      type: Boolean,
      default: false
    },
    isSameDay: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(useDtfStore, ["isDtfSheet", "productSlug"])
  }
};
</script>

<style lang="scss" scoped>
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.product-details-delivery-date-simple {
  $this: &;

  background-color: transparent;
  min-height: 116px;
  border-radius: 4px;
  border: 1px solid $green-lightest;
  background: $flash-green-whitest;

  &__change-location-button {
    background-color: transparent;
    padding: 0 10px;
  }

  &__wrapper {
    padding: 20px 0 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
  }

  &__delivery {
    justify-content: center;
    align-items: center;
    gap: 5px;
    z-index: 0;
  }

  &__delivery-icon {
    position: unset;
    width: 23px;
    height: 23px;

    &--box {
      color: $green-dark;
    }

    &--same-day {
      color: $accent-grapefruit;
      display: none;
    }
  }

  &__change-location-button {
    border-top: 1px solid $gray-border;
    position: unset;
    padding: 0;
    margin-top: 10px;
    justify-content: center;
  }

  &__loading {
    z-index: 0;
    position: unset;
    width: 100%;
    background: transparent;

    &:before {
      background: transparent;
    }
  }

  &__loading-text {
    margin-left: 0;
  }

  &__delivery-date-label {
    font-weight: normal;
    display: flex;
    align-items: baseline;
    justify-content: center;
    flex-wrap: wrap;
    gap: 5px;
  }

  &__flash-delivery-label {
    font-weight: 700;
    color: $accent-grapefruit;
    display: none;
  }

  &__delivery-date-value {
    font-weight: bold;
  }

  &__cutoff-date {
    color: black;
  }

  &__change-location-button {
    border-top-color: $green-lightest;
  }

  &--same-day {
    margin: 0;
    border-color: $flash-orange;
    background: linear-gradient(
      90deg,
      rgba($flash-orange-light, 0.15) 0%,
      rgba($flash-orange-dark, 0.15) 100%
    );

    #{$this}__loading-text,
    #{$this}__deliver-to-message,
    #{$this}__delivery-date-label {
      color: $accent-grapefruit;
    }

    #{$this}__flash-delivery-label {
      display: block;
    }

    #{$this}__delivery-icon {
      &--box {
        display: none;
      }

      &--same-day {
        display: block;
      }
    }

    #{$this}__change-location-button {
      border-top-color: rgba($flash-orange-light, 0.25);
      text-decoration-color: $accent-grapefruit;
    }
  }

  &--compact {
    max-height: 110px;
    min-height: auto;

    #{$this}__wrapper {
      padding: 10px 20px;
    }

    @include with-desktop {
      max-height: 64px;
    }
  }
}
</style>
